import * as React from 'react';
import * as H from "../../../hooks";
import * as C from "../../../Common";
import * as BS from 'react-bootstrap';
import * as R from "../../../reducers";
import { useSelector } from 'react-redux';
import { T, TC } from "../../../Constants";
import * as FA from '@fortawesome/react-fontawesome';

const NotificationDropdown: React.FC = () => {
  const lg = H.useLanguage();
  const is_open = H.useBoolean(false);
  const notifications = useSelector((state: T.ReduxSelector) => state.notifications);
  const is_all_read = React.useMemo(() => notifications.every(n => n.read), [notifications]);

  const toggle_class = React.useMemo(() => {
    const classes = ["px-0", "nav-link", "pointer"];
    if (!is_all_read) classes.push("notification-indicator", "notification-indicator-danger");
    return classes.join(" ");
  }, [is_all_read]);

  const markAsRead = React.useCallback<React.MouseEventHandler<HTMLAnchorElement>>(event => {
    event.preventDefault();
    R.READ_ALL_NOTIFICATIONS();
  }, []);

  return <BS.Dropdown navbar as="li" show={is_open.value} onToggle={is_open.toggle}>

    <BS.Dropdown.Toggle bsPrefix="toggle" as="a" className={toggle_class} >
      <FA.FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-4" />
    </BS.Dropdown.Toggle>

    <BS.Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
      <BS.Card className="dropdown-menu-notification dropdown-menu-end shadow-none" style={{ maxWidth: '20rem' }} >

        <C.Falcon.CardHeader
          className="text-dark"
          title={lg.getStaticText(TC.GLOBAL_NOTIFICATIONS)}
          endEl={<C.IconTip icon="check-double pointer" onClick={markAsRead} className='text-info' tipContent={TC.NOTIFICATION_MARK_ALL_AS_READ} />}
        />

        <BS.ListGroup variant="flush" className="fw-normal fs--1 scrollbar" style={{ maxHeight: '19rem' }} >

          {/* <div className="list-group-title">NEW</div> */}

          {notifications.length > 0
            ? notifications.map(notification => <BS.ListGroup.Item key={notification._id} onClick={is_open.toggle}>
              {/* Only show the notification if the dropdown is open, to force the re-render of the relative date */}
              {is_open.value && <C.Notification
                flush
                show_time="relative"
                read={notification.read}
                texts={notification.text}
                emoji={notification.emoji}
                link={notification.redirect}
                time={notification.createdAt}
                on_read={() => R.READ_NOTIFICATION(notification._id)}
              />}
            </BS.ListGroup.Item>)
            : <BS.ListGroup.Item>
              <C.CenterMessage
                bold
                size="sm"
                padding={2}
                children={TC.EMPTY_NOTIFS_LIST}
              />
            </BS.ListGroup.Item>}
        </BS.ListGroup>

        {/* <div className="card-footer text-center border-top" onClick={is_open.toggle} >
          <Link className="card-link d-block" to="#!"> View all </Link>
        </div> */}

      </BS.Card>
    </BS.Dropdown.Menu>
  </BS.Dropdown>
};

export default NotificationDropdown;